import React from "react";
import About from "../about/about";
// import ContactForm from "../contact-form/contact-form";
// import Projects from "../projects/projects";
import Summary from "../summary/summary";
import GameHistory from "../game-history/game-history";

const MainContent = ({ players, history }) => {
  return (
    <main className="lg:w-2/3 lg:pl-8 xl:pl-12">
      <Summary players={players} history={history} />
      <About />
      {/* <Projects /> */}
      <GameHistory players={players} history={history} />
      {/* <ContactForm /> */}
    </main>
  );
};

export default MainContent;
